<template>
    <div>

        <v-container fluid class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Debtors</div>
                </div>
            </div>
            <div v-if="debtors">
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left">
                                            Age
                                        </th>
                                        <th class="text-left">
                                            Total
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                    >
                                        <td>Total</td>
                                        <td>{{ totalDebts|toCurrency }}</td>
                                    </tr>
                                    <tr
                                            v-for="range in rangeTotals"
                                            :key="range.age"
                                            :style="{backgroundColor: range.color}"
                                    >
                                        <td>{{ range.age }} Days</td>
                                        <td>{{ range.total|toCurrency }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>


                    </v-col>
                    <v-col cols="9">

                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">
                                        Age
                                    </th>
                                    <th class="text-left">
                                        Booking ID
                                    </th>
                                    <th class="text-left">
                                        Invoice ID
                                    </th>
                                    <th class="text-left">
                                        PO
                                    </th>
                                    <th class="text-left">
                                        Customer
                                    </th>
                                    <th class="text-left">
                                        Gross
                                    </th>
                                    <th class="text-left">
                                        Tax Date
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                        v-for="debtor in debtors"
                                        :key="debtor.id"
                                        :style="{backgroundColor: getColor(debtor.age)}"
                                >
                                    <td>{{ debtor.age }}</td>
                                    <td>
                                        <v-btn :to="{name:'booking-view', params: {id:  debtor.id}}"
                                               small
                                        >BK-{{ debtor.id }}
                                        </v-btn>
                                    </td>
                                    <td>
                                        <router-link :to="xeroInvoiceUrl(debtor.invoiceNumber)">
                                            {{ debtor.invoiceNumber }}
                                        </router-link>
                                    </td>
                                    <td>{{ debtor.customerPoRef }}</td>
                                    <td>{{ debtor.contactCompany }}</td>
                                    <td>{{ debtor.totalPrice|toCurrency }}</td>
                                    <td>{{ debtor.taxDate|formatDate }}</td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
    import DEBTORS from "../graphql/Bookings/Debtors.gql";

    export default {

        data() {
            return {
                ranges: [
                    {age: 90, color: '#FFCCCC'},
                    {age: 60, color: '#FFCC66'},
                    {age: 45, color: '#FFFF99'},
                    {age: 30, color: '#99FFFF'},
                    {age: 0, color: '#CCFF33'}
                ]
            }
        },
        apollo: {
            debtors: {
                query: DEBTORS,
                update: data => data.debtors
            },
        },
        computed: {

            rangeTotals() {

                let ranges = JSON.parse(JSON.stringify(this.ranges));


                ranges.forEach((range) => {
                    range.total = 0
                });

                this.debtors.forEach((debtor) => {
                    console.log(debtor)
                    let range = ranges.find((range) => debtor.age > range.age);
                    console.log(range)
                    range.total = range.total + debtor.totalPrice

                })

                return ranges
            },

            totalDebts() {
                let total = 0
                this.debtors.forEach((debtor) => {
                    total = total + debtor.totalPrice

                })
                return total
            }

        },
        methods: {
            getColor(age) {
                return this.ranges.find((range) => age > range.age).color
            },
            xeroInvoiceUrl(invoiceId) {
                return 'https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=' + invoiceId;
            },
        }
    }
</script>

<style scoped>

</style>